module.exports = __webpack_public_path__ + "static/img/callImg.3a72a76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/callImg.png
// module id = 1ROf
// module chunks = 1